const autoNgTemplateLoaderTemplate1 = require('./endpointList.html');

angular.module('shbdeployer.app').component('endpointList', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller: 'EndpointListController',
  bindings: {
    titleText: '@',
    titleIcon: '@',
    tags: '<',
    tableKey: '@',
    dashboardAction: '<',
    snapshotAction: '<',
    showSnapshotAction: '<',
    editAction: '<',
    isAdmin: '<',
    retrievePage: '<',
    endpointInitTime: '<',
  },
});
